// Helpers for declaring the built-in profiles.
import { makeRule } from "../stylemap.js";
import { normaliseProfile } from "./schema.js";

export const rule = (fields) => makeRule({ group: "main", ...fields });
export const para = (style, html, sample) => rule({ match: "p", style, html, sample });
export const run = (style, html) => rule({ match: "r", style, html, sample: "inline" });
export const quietPara = (style) => makeRule({ match: "p", style, html: "p:fresh", group: "quiet", sample: "paragraph" });
export const quietRun = (style) => makeRule({ match: "r", style, html: "", group: "quiet", sample: "inline" });

export function overrideKey(r) {
  return `${r.match}|${r.style ?? ""}${r.prefix ? "*" : ""}`;
}

export function override(rules, changes) {
  const known = new Set(rules.map(overrideKey));
  for (const key of Object.keys(changes)) {
    if (!known.has(key)) throw new Error(`override: no rule matches "${key}"`);
  }
  return rules.map((r) => {
    const change = changes[overrideKey(r)];
    return change ? makeRule({ ...r, ...change }) : r;
  });
}

export function builtIn(definition) {
  const { profile, errors } = normaliseProfile({
    schema: 1, css: [], exportCss: [], extraCss: "", wrapper: "", exportWrapper: "",
    ...definition,
    builtIn: true,
  });
  if (!profile || errors.length) {
    throw new Error(`Built-in profile "${definition.name}" is invalid: ${errors.join("; ")}`);
  }
  return profile;
}
